export default "__VITE_ASSET__HxovZDba__"